import { MainScene } from './MainScene';

export enum ScenesName {
  Main = 'MainScene',
}

export const sceneMap = {
  [ScenesName.Main]: MainScene,
}